import { styled } from '@mui/material/styles';

export const WrapperWithAlert = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;
